import React, { FC, useState, useEffect } from 'react';
import {
  initI18n,
  I18nextProvider,
  useSettingsEnvironment,
} from '@wix/yoshi-flow-editor';

import { useFetchTranslations } from './use-fetch-translations';

interface TranslationsProviderProps {
  translationsName: string;
  loadingIndicator?: FC;
}

const TranslationsProvider: FC<TranslationsProviderProps> = ({
  children,
  translationsName,
  loadingIndicator: LoadingIndicator,
}) => {
  const [i18n, setI18n] = useState<any | null>(null);
  const { siteLanguage } = useSettingsEnvironment();
  const translationsState = useFetchTranslations({
    language: siteLanguage,
    translationsName,
  });

  useEffect(() => {
    if (
      !translationsState.isLoading &&
      translationsState.data &&
      !translationsState.error
    ) {
      const i18nHolder = initI18n({
        disableAutoInit: true,
        locale: 'en',
        messages: translationsState.data,
      });
      i18nHolder.init();
      setI18n(i18nHolder);
    }
  }, [
    translationsState.data,
    translationsState.error,
    translationsState.isLoading,
  ]);

  if (!i18n) {
    return LoadingIndicator ? <LoadingIndicator /> : null;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default TranslationsProvider;
